<template>
  <!-- <div class="flex flex-col flex-1"> -->
  <SoftwareLicenseSelectionList
    ref="list"
    disabled
    :software-asset-id="resourceId"
    :searchable="false"
    :show-no-data="false"
    :has-actions="false"
  />
  <!-- </div> -->
</template>

<script>
import SoftwareLicenseSelectionList from '@components/item-selection-list/software-license-list'
export default {
  name: 'SoftwareLicenseTab',
  components: { SoftwareLicenseSelectionList },
  props: {
    resourceId: { type: Number, required: true },
    disabled: { type: Boolean, default: false },
  },
}
</script>
